import Switcher from "./Switcher.js";
import { setLayout, getLayout } from "../store/index.js";
class LayoutSwitcher extends Switcher {
  static config = {
    name: "LayoutSwitcher"
  };
  async mounted() {
    const value = await getLayout();
    const input = this.$refs.inputs.find((i) => i.value === value);
    if (input) {
      this.$write(() => {
        input.checked = true;
      });
    }
  }
  switch(value) {
    setLayout(value);
  }
}
export {
  LayoutSwitcher as default
};
//# sourceMappingURL=LayoutSwitcher.js.map
